import React from 'react';

import { Header } from '@growth/dweb-header';

const HeaderWrapper = ({ hideHeader, location }) => {
  // TODO: needs to be tested properly
  const handleOnLoginSuccess = () => {
    location.reload();
  };

  const handleOnLogoutSuccess = () => {
    location.reload();
  };

  // if (hideHeader) {
  //   return (
  //     <Header
  //       lobName="flights"
  //       onLoginSuccess={handleOnLoginSuccess}
  //       onLogoutSuccess={handleOnLogoutSuccess}
  //       hideHeader={hideHeader}
  //     />
  //   );
  // }

  return (
    <Header
      lobName="flights"
      onLoginSuccess={handleOnLoginSuccess}
      onLogoutSuccess={handleOnLogoutSuccess}
      hideHeader={hideHeader}
    />
  );
};

export default HeaderWrapper;
